import React, {Fragment} from 'react';
import {Link} from "react-router-dom";

import Icon from '../../components/Icon';

const PaginationByAncre = ({
                        currentPage = 1, pagesCount = 1, paginationLength = 10, previousShow = true, nextShow = true, link = false, paramsUrl = "", handleChangePage = () => {
    }
                    }) => {

    currentPage = parseInt(currentPage);

    pagesCount = parseInt(pagesCount);

    if(paramsUrl){
        let urlSearchParams = new URLSearchParams(paramsUrl.replace("#", ""));
        //urlSearchParams.delete("page");
        paramsUrl = urlSearchParams.toString();
    }

    let canPrevious = (currentPage > 1);
    let canNext = (currentPage < pagesCount);


    const transformCountInArray = (count) => {
        let countArray = [];
        for (let i = 0; i < count; i++) {
            countArray.push(i + 1);
        }
        return countArray;
    };
    const slicedPages = () => {
        let sliceReferPage = (currentPage <= (Math.ceil(paginationLength / 2) - 1)) ? 1 : (currentPage > pagesCount - (Math.ceil(paginationLength / 2) - 1)) ? (pagesCount - paginationLength) + 1 : currentPage - (Math.ceil(paginationLength / 2) - 1);
        return (pagesCount > paginationLength) ? transformCountInArray(pagesCount).slice(sliceReferPage - 1, sliceReferPage - 1 + paginationLength) : transformCountInArray(pagesCount);
    };
    const handleClickPrevious = () => {
        canPrevious && handleChangePage((currentPage - 1), link);
    };
    const handleClickNext = () => {
        canNext && handleChangePage((currentPage + 1), link);
    };
    const handleClickFirst = () => {
        handleChangePage(1, link);
    };
    const handleClickLast = () => {
        handleChangePage(pagesCount, link);
    };

    // window.scrollTo(0, 0);
    return (
        <div className="pagination">
            <div className="pagination-btn-group ">
                {canPrevious && (
                    <Fragment>
                        <Link
                            to={`${link}${paramsUrl ? currentPage <= 2 ? `#${paramsUrl}` : `${currentPage - 1}#${paramsUrl}` : `#${paramsUrl}`}`}
                              onClick={() => handleClickPrevious()}
                              className={`pagination-btn ${(!previousShow) && 'hidden'}`}
                            rel={"prev"}
                        >
                            <Icon type="caret-left"/>
                            Précédent
                        </Link>
                        <Link to={`${link}${paramsUrl ? `#${paramsUrl}` : ""}`}
                              className={`pagination-btn first-page ${(currentPage === 1) && 'active'} ${(!previousShow) && 'hidden'}`}
                              onClick={() => handleClickFirst()}
                        >
                            Première
                        </Link>
                    </Fragment>
                )}

                <div className={"pagination-number-container"}>
                    {slicedPages().map((item) => {

                        if(item === 1){
                            return (
                                <Link to={`${link}${paramsUrl ? `#${paramsUrl}` : ""}`}
                                      key={item}
                                      onClick={() => handleChangePage(item, link)}
                                      className={`pagination-btn ${(item === currentPage) && 'active'}`}
                                >
                                    {item}
                                </Link>
                            )
                        } else {
                            return (
                                <Link to={`${link}${item}${paramsUrl ? `#${paramsUrl}`  : ``}`}
                                      key={item}
                                      onClick={() => handleChangePage(item, link)}
                                      className={`pagination-btn ${(item === currentPage) && 'active'}`}
                                >
                                    {item}
                                </Link>
                            )
                        }
                    })}
                </div>
                {canNext && (
                    <Fragment>
                        <Link to={`${link}${pagesCount}${paramsUrl ? `#${paramsUrl}`  : ``}`}
                              onClick={() => handleClickLast()}
                              className={`pagination-btn last-page ${(!nextShow && pagesCount <= paginationLength) && 'hidden'}`}
                        >
                            ... {pagesCount}
                        </Link>
                        <Link to={`${link}${currentPage < pagesCount ? currentPage + 1 : currentPage}${paramsUrl ? `#${paramsUrl}`  : ``}`}
                              onClick={() => handleClickNext()}
                              className={`pagination-btn ${(!nextShow) && 'hidden'}`}
                              rel={"next"}
                        >
                            Suivant
                            <Icon type="caret-right"/>
                        </Link>
                    </Fragment>
                )}

            </div>
        </div>
    )
};

export default PaginationByAncre;

